// Dialog outlet component for the library page

import React from 'react';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';
import { LIBRARY_OUTLET_DIALOGS } from './registry';

const DialogOutlet: React.FC<LibraryDialogOutletProps> = (props) => {
  return (
    <>
      {LIBRARY_OUTLET_DIALOGS.map(({ key, component: DialogComponent }) => {
        return <DialogComponent key={key} {...props} />;
      })}
    </>
  );
};

export default DialogOutlet;
